import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="px-4 md:px-40 flex flex-1 justify-center py-5 min-h-screen bg-[#0a090c]">
      <div className="layout-content-container flex flex-col max-w-[960px] flex-1">
        
        {/* HERO SECTION */}
        <div className="@container">
          <div className="@[480px]:p-4">
            <div
              className="flex min-h-[480px] flex-col gap-6 bg-cover bg-center bg-no-repeat @[480px]:gap-8 @[480px]:rounded-xl items-center justify-center px-4 pb-10 @[480px]:px-10 relative overflow-hidden group"
              style={{
                backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.8) 100%), url("https://cdn.usegalileo.ai/sdxl10/b8b8b8b8-b8b8-b8b8-b8b8-b8b8b8b8b8b8.png")'
              }}
            >
              {/* Animated Background Overlay */}
              <div className="absolute inset-0 bg-[#5b13ec]/10 mix-blend-overlay opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>

              <div className="flex flex-col gap-4 text-center z-10 max-w-[700px]">
                <div className="flex items-center justify-center gap-4 mb-2 opacity-80">
                   <span className="text-white font-bold tracking-widest text-xs uppercase">BytePlus</span>
                   <span className="text-gray-400 text-xs">✕</span>
                   <span className="text-white font-bold tracking-widest text-xs uppercase">Sisnet Mitra</span>
                </div>

                <h1
                  className="text-white text-5xl font-black leading-tight tracking-[-0.033em] @[480px]:text-6xl drop-shadow-xl"
                >
                  Creative Suite
                </h1>
                <h2 className="text-gray-200 text-lg font-normal leading-relaxed @[480px]:text-xl max-w-xl mx-auto">
                  Platform terpadu untuk kreasi Generative AI dan manajemen video profesional.
                </h2>
              </div>

              {/* MAIN CTA BUTTON */}
              <div className="z-10 mt-4 animate-bounce-slow">
                <Link to="/vod">
                  <button className="flex min-w-[200px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-14 px-8 bg-[#5b13ec] hover:bg-[#4a0fc7] text-white text-lg font-bold tracking-wide shadow-[0_0_20px_rgba(91,19,236,0.5)] hover:shadow-[0_0_30px_rgba(91,19,236,0.7)] transition-all duration-300 transform hover:scale-105">
                    <span className="mr-2">🚀</span> Launch Studio
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        {/* FEATURES TEASER */}
        <div className="flex flex-col gap-10 px-4 py-10 @container">
          <div className="flex flex-col gap-4">
            <h1
              className="text-white text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 text-center pb-3 pt-5 border-b border-[#2e2839]"
            >
              What's Inside
            </h1>
            <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 p-4">
              
              {/* Feature 1 */}
              <div className="flex flex-1 gap-3 rounded-xl border border-[#2e2839] bg-[#1c1a21] p-6 flex-col hover:border-[#5b13ec] transition-colors group">
                <div className="text-white p-3 bg-[#2e2839] w-fit rounded-lg group-hover:bg-[#5b13ec] transition-colors">
                  <span className="text-2xl">🎨</span>
                </div>
                <div className="flex flex-col gap-1">
                  <h2 className="text-white text-base font-bold leading-tight">Seedream Image Gen</h2>
                  <p className="text-[#a69db9] text-sm font-normal leading-normal">
                    Ubah teks menjadi gambar visual berkualitas tinggi dalam hitungan detik.
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="flex flex-1 gap-3 rounded-xl border border-[#2e2839] bg-[#1c1a21] p-6 flex-col hover:border-[#5b13ec] transition-colors group">
                <div className="text-white p-3 bg-[#2e2839] w-fit rounded-lg group-hover:bg-[#5b13ec] transition-colors">
                  <span className="text-2xl">🎥</span>
                </div>
                <div className="flex flex-col gap-1">
                  <h2 className="text-white text-base font-bold leading-tight">Seedance Motion</h2>
                  <p className="text-[#a69db9] text-sm font-normal leading-normal">
                    Hidupkan gambar statis menjadi video sinematik dengan AI Motion terbaru.
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="flex flex-1 gap-3 rounded-xl border border-[#2e2839] bg-[#1c1a21] p-6 flex-col hover:border-[#5b13ec] transition-colors group">
                <div className="text-white p-3 bg-[#2e2839] w-fit rounded-lg group-hover:bg-[#5b13ec] transition-colors">
                  <span className="text-2xl">🗣️</span>
                </div>
                <div className="flex flex-col gap-1">
                  <h2 className="text-white text-base font-bold leading-tight">OmniHuman</h2>
                  <p className="text-[#a69db9] text-sm font-normal leading-normal">
                    Buat karakter berbicara (Talking Head) hanya dengan foto dan file audio.
                  </p>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="flex flex-1 gap-3 rounded-xl border border-[#2e2839] bg-[#1c1a21] p-6 flex-col hover:border-[#5b13ec] transition-colors group">
                <div className="text-white p-3 bg-[#2e2839] w-fit rounded-lg group-hover:bg-[#5b13ec] transition-colors">
                  <span className="text-2xl">📺</span>
                </div>
                <div className="flex flex-col gap-1">
                  <h2 className="text-white text-base font-bold leading-tight">VOD Library</h2>
                  <p className="text-[#a69db9] text-sm font-normal leading-normal">
                    Manajemen aset video terpusat dengan player HTML5 yang ringan.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Footer Copyright */}
        <div className="mt-auto py-6 text-center opacity-60">
            <div className="text-[10px] md:text-xs font-mono tracking-wide text-center">
                <span className="text-gray-600">&copy; 2025-2026</span>
                <span className="mx-2 text-gray-400 italic">Research and Development Team</span>
                <span className="text-[#5b13ec] font-bold">@</span>
                <span className="ml-2 text-white font-bold tracking-widest uppercase">Sisnet Mitra</span>
            </div>
        </div>

      </div>
    </div>
  );
};

export default Home;